// Decals on the receiver (a per-gun decal token): dots, a stripe, a star, fizz bubbles or a chevron.
import type { Ctx2D } from '../../ctx.ts';
import { fillP } from '../../passes.ts';
import { circle, poly, roundPoly, rrect, starPts } from '../../shapes.ts';
import type { GunKit } from './types.ts';

export function decal(g: GunKit, tok: string): (c: Ctx2D) => void {
  const { kind } = g.r.decal;
  const { x, y, w, h } = g.r.receiver;
  const col = g.pal.sw(tok).base;
  return (c) => {
    if (kind === 'dots') {
      for (const fx of [0.3, 0.55]) fillP(c, circle(x + w * fx, y + h * 0.42, 2.6), col);
    } else if (kind === 'stripe') {
      fillP(c, rrect(x + w * 0.12, y + h * 0.36, w * 0.62, 3.2, 1.6), col);
    } else if (kind === 'star') {
      fillP(c, roundPoly(starPts(x + w * 0.42, y + h * 0.48, 5, 2.3, 5), 0.6), col);
    } else if (kind === 'bubbles') {
      for (const [fx, fy, r] of [
        [0.3, 0.4, 2.6],
        [0.5, 0.62, 2],
        [0.66, 0.36, 1.6],
      ] as const) {
        fillP(c, circle(x + w * fx, y + h * fy, r), col);
      }
    } else {
      fillP(
        c,
        poly([
          [x + w * 0.3, y + h * 0.3],
          [x + w * 0.44, y + h * 0.5],
          [x + w * 0.3, y + h * 0.7],
          [x + w * 0.38, y + h * 0.7],
          [x + w * 0.52, y + h * 0.5],
          [x + w * 0.38, y + h * 0.3],
        ]),
        col,
      );
    }
  };
}
